import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html {
    position: relative;
  }

  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  body {
    font-family: 'Montserrat';
    margin: 0px;
    padding: 0px;
    position: relative;
    background: rgb(192, 199, 211);

    hr {
        margin: 2rem auto;
        width: 70%;
        border-style: solid none none none;
        border-width: 2px;
        border-color:  #ddd;;
    }

    h1, h2, h3 {
      color: #333;
    }
  }
`
